var exports = {
  "q": "BaseSettingsPage__CerwZX",
};

module.exports = exports;
